import React from "react";
import { Card } from "react-bootstrap";
import styles from "./logo_header.module.scss"; // Adjust the path if necessary
import seLogo from "../../../images/logo/SEHQC-Logo-Stacked-Color-Clear.svg";

const LogoHeader = () => {
  return (
    <Card.Header className={styles.header}>
      <img src={seLogo} alt="SE Healthcare" />
    </Card.Header>
  );
};

export default LogoHeader;